<script lang="ts" setup>
import { ref, computed } from 'vue'
import BsButtonNormal from '@/legacy/components/ButtonNormal.vue'
import { ButtonNormalTheme, ButtonSize } from '@/types/ButtonLegacy'
import { createGAEvent, GaGeneralEvent } from '@/assets/ts/customEvent'
import { getCurrentGaPageName } from '@/lib/utils'

defineProps({
	text: {
		type: String,
		default: 'Download Now',
	},
})

const appName = ref('Buyandship://')

const currentCountry = computed(() => {
	return window.BUYANDSHIP.settings.current_country
})
const appStoreUrl = computed(() => {
	return `https://apps.apple.com/app/buandship/id1474193162?ct=${currentCountry.value}_site_footer&vt=lo&mt=8`
})
const googlePlayStoreUrl = computed(() => {
	return `https://play.google.com/store/apps/details?id=com.buynship.BuyandshipApp&referrer=utm_source%3D${currentCountry.value}_site_footer_GooglePlay%26utm_medium%3D${currentCountry.value}_site_footer_GooglePlay`
})

function getMobileOperatingSystem() {
	// @ts-ignore
	const userAgent = navigator.userAgent || navigator.vendor || window.opera
	if (/windows phone/i.test(userAgent)) return 'android'
	if (/android/i.test(userAgent)) return 'android'
	// @ts-ignore
	if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) return 'ios'
	if (/Macintosh/i.test(navigator.userAgent)) {
		try {
			document.createEvent('TouchEvent')
			return 'ios'
		} catch (e) {
			return 'unknown'
		}
	}
	return 'unknown'
}

function goTo() {
	createGAEvent(GaGeneralEvent.ButtonClick, {
		page_name: getCurrentGaPageName(),
		button_name: 'User Dropdown Menu App Download',
	})

	const deviceSystem = getMobileOperatingSystem()
	if (deviceSystem === 'ios') {
		getAppIOS()
	} else if (deviceSystem === 'android') {
		getAppAndroid()
	}
}

function getAppIOS() {
	setTimeout(() => {
		window.location.href = appName.value
	}, 1)

	setTimeout(() => {
		window.location.href = appStoreUrl.value
	}, 50)

	setTimeout(() => {
		window.location.reload()
	}, 150)
}

function getAppAndroid() {
	window.location.href = appName.value
	setTimeout(() => {
		window.location.href = googlePlayStoreUrl.value
	}, 250)

	setTimeout(() => {
		window.location.reload()
	}, 1200)
}
</script>

<template>
	<BsButtonNormal
		class="bs-app-install-prompt__only-button"
		:text="text"
		:theme="ButtonNormalTheme.Revamp"
		:size="ButtonSize.Large"
		:isFullWidth="true"
		:action="goTo"
	></BsButtonNormal>
</template>
